import { type App, inject, ref, type Ref } from 'vue'
import type { Client } from '@urql/vue'

const key = '__plugin.graphql-client'

export interface GraphqlClientPlugin {
    client: Ref<Client>
    resetApiClient: () => void
}

export function installGraphqlClient(
    app: App,
    factory: () => Client
): GraphqlClientPlugin {
    const client = ref(factory())
    const graphqlClient: GraphqlClientPlugin = {
        client,
        resetApiClient: () => {
            client.value = factory()
        },
    }

    app.provide(key, graphqlClient)

    return graphqlClient
}

function useGraphqlClientPlugin(): GraphqlClientPlugin {
    return inject(key) as GraphqlClientPlugin
}

export function useGraphqlClient(): Ref<Client> {
    return useGraphqlClientPlugin().client
}

export function useResetApiClient(): () => void {
    return useGraphqlClientPlugin().resetApiClient
}
